import {
    Heading,
    HStack,
    Text,
    VStack,
    Icon,
    Button,
    Tooltip,
    Box,
    Drawer,
    DrawerContent,
    DrawerBody,
    DrawerCloseButton,
    IconButton,
    Center,
} from '@chakra-ui/react';
import React, { Suspense } from 'react';
import { CardSpinner } from '../../../../../../../domain';
import { ReportingViewBaseConfig } from '../../../base';
import { RecordUpsertViewProps } from './recordUpsertProps';
import { AiOutlineClose } from 'react-icons/ai';
import { RecordEditContainerProps } from '../edit';
import { RecordNewContainerProps } from '../new';

export function createRecordUpsertView(
    config: Omit<ReportingViewBaseConfig, 'Container'> & {
        Container: {
            New: React.FC<RecordNewContainerProps>;
            Edit: React.FC<RecordEditContainerProps>;
        };
    }
): React.FC<RecordUpsertViewProps> {
    const {
        Container: { New: RecordNewContainer, Edit: RecordEditContainer },
    } = config;

    return (props) => {
        return (
            <Drawer
                {...props.drawer}
                placement="right"
                size={{ base: 'md', xl: 'lg', '2xl': 'xl' }}
                returnFocusOnClose={false}
            >
                <DrawerContent
                    bg="black"
                    _focus={{ outline: 'none' }}
                    position="relative"
                    p={0}
                    overflowY="hidden"
                >
                    <DrawerBody
                        bg="whiteAlpha.100"
                        p={{ base: 4, md: 8, xl: 12, '2xl': 16 }}
                        position="relative"
                    >
                        <DrawerCloseButton
                            as={IconButton}
                            icon={<Icon as={AiOutlineClose} />}
                            variant="ghost"
                            color="whiteAlpha.700"
                            borderWidth={1}
                            position="fixed"
                            top={4}
                            right={4}
                            borderColor="whiteAlpha.200"
                            borderRadius="full"
                            // size="md"
                            bg="none"
                            _hover={{ bg: 'whiteAlpha.50' }}
                            _focus={{ outline: 'none', shadow: 'none' }}
                        />
                        <Suspense
                            fallback={
                                <Center w="full" h="full">
                                    <HStack w="full" align="center" justify="center">
                                        <CardSpinner />
                                    </HStack>
                                </Center>
                            }
                        >
                            {props.mode?.kind === 'new' && (
                                <RecordNewContainer {...props.mode} />
                            )}
                            {props.mode?.kind === 'edit' && (
                                <RecordEditContainer {...props.mode} />
                            )}
                        </Suspense>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        );
    };
}
